export const FILTER_CONTROL_SIZE = "small" as const

export const FILTER_SELECT_WIDTH = {
  environment: 113,
  granularity: 132,
  compare: 146,
} as const

export const FILTER_RANGE_MIN_WIDTH = 156
export const FILTER_TENANT_MIN_WIDTH = 185
